import React from "react";
import { cn } from "@/lib/utils";

// El estado se lee por el punto + la palabra, nunca sólo por color.
// "blue" se conserva como alias histórico para estados "activos" que no
// son ni éxito ni alerta (asignada, aceptada, facturado) — usa el punto
// en tinta plena en vez de un color inventado fuera de los tokens.
const TONES = {
  green: "var(--state-ok)",
  amber: "var(--state-warn)",
  red: "var(--state-critical)",
  gray: "var(--state-neutral)",
  blue: "var(--ink)",
};

export const StatusChip = ({ tone = "gray", label, className, testId }) => (
  <span
    data-testid={testId}
    className={cn(
      "inline-flex items-center gap-1.5 whitespace-nowrap rounded-control border border-line px-1.5 py-[3px] text-[12px] font-medium leading-none text-ink",
      className
    )}
  >
    <span
      className="h-[6px] w-[6px] shrink-0 rounded-full"
      style={{ backgroundColor: TONES[tone] || TONES.gray }}
    />
    {label}
  </span>
);

export const statusTone = (status) => (status === "active" ? "green" : "gray");

export const countTone = (count, warn = 1, danger = 1) => {
  if (!count) return "gray";
  if (count >= danger) return "red";
  if (count >= warn) return "amber";
  return "green";
};
